<template>
  <div class="expand-table-container">
    <div ref="header" class="header-box">
      <div class="header-line">
        <span class="header-label">归属店铺</span>
        <el-select placeholder="请选择" size="small" v-model="amazonShopId">
          <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="header-line">
        <el-button type="primary" size="small" @click="resetAndQuery">重置</el-button>
        <el-button type="primary" size="small" @click="getDataList">查询</el-button>
      </div>
    </div>
    <el-table
      :data="tableData"
      :expand-row-keys="expandedRowKeys"
      @row-click="handleRowClick"
      :row-key="'id'"
      border
      style="width: 100%"
      v-loading="loading"
    >
      <el-table-column type="expand">
        <template slot-scope="scope">
          <div v-for="(key, index) in Object.keys(scope.row.children).filter(k => k !== 'rank')" :key="index">
            <el-table :data="[{ key }]" border :show-header="false" style="width: 100%">
              <el-table-column prop="" width="50"></el-table-column>
              <el-table-column prop="" width="120"></el-table-column>
              <el-table-column prop="" width="80"></el-table-column>
              <el-table-column prop="" width="150"></el-table-column>
              <el-table-column width="80">
                <template slot-scope="subScope">
                  {{ targetTap[key] }}
                </template>
              </el-table-column>
              <el-table-column
                v-for="date in dates"
                :key="date"
                :label="date"
                width="100"
              >
                <template slot-scope="subScope">
                  {{ scope.row.children[subScope.row.key][date] || 0 }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </el-table-column>

      <el-table-column type="index" label="序号" width="120"></el-table-column>

      <el-table-column label="图片" width="80">
        <template slot-scope="scope">
          <el-image
            :src="`/images/${scope.row.image}.png`"
            fit="cover"
            width="40"
            height="40"
          ></el-image>
        </template>
      </el-table-column>

      <el-table-column prop="title" label="标题" width="150"></el-table-column>

      <el-table-column label="指标" width="80">
        <template slot-scope="scope">
          {{ targetTap['rank'] }}
        </template>
      </el-table-column>

      <el-table-column
        v-for="date in dates"
        :key="date"
        :label="date"
        width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.children.rank[date] || 0 }}
        </template>
      </el-table-column>
    </el-table>

    <!-- 简化分页组件：只保留前后翻页 -->
    <div class="pagination-container">
      <el-pagination
        @prev-click="handlePrevClick"
        @next-click="handleNextClick"
        :current-page="currentPage"
        :disabled-prev="currentPage === 1"
        :disabled-next="!hasNextPage"
        layout="prev, next"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {bigdataRequest} from "@r";

export default {
  name: "CommodityTable",
  data() {
    return {
      dates: [],
      tableData: [],          // 接口返回的当前页数据
      expandedRowKeys: [],    // 展开行ID集合
      targetTap: {"rank": "排名", "comments": "评论数", "score": "评分", "sales": "销量"},
      // 分页相关配置
      currentPage: 1,         // 当前页码（默认第一页）
      pageSize: 2,            // 每页显示条数（固定，可配置）
      amazonShopId: '',       // 店铺ID筛选条件
      loading: false,         // 加载状态
      hasNextPage: false,     // 是否有下一页（由接口返回结果判断）
      shopList: []

    };
  },
  computed: {},
  methods: {
    // 行点击：展开/折叠
    handleRowClick(row) {
      const index = this.expandedRowKeys.indexOf(row.id);
      if (index > -1) {
        this.expandedRowKeys.splice(index, 1);
      } else {
        this.expandedRowKeys.push(row.id);
      }
    },

    // 上一页点击
    handlePrevClick() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getDataList(); // 翻页触发查询
      }
    },

    // 下一页点击
    handleNextClick() {
      if (this.hasNextPage) {
        this.currentPage++;
        this.getDataList(); // 翻页触发查询
      }
    },

    // 重置并查询（回到第一页）
    resetAndQuery() {
      this.amazonShopId = '';
      this.currentPage = 1;
      this.expandedRowKeys = [];
      this.getDataList();
    },

    // 获取列表数据（翻页/查询时调用）
    getDataList() {
      this.loading = true;
      this.expandedRowKeys = []; // 切换页码时清空展开行，避免数据错乱

      bigdataRequest.commodityList({
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        amazonShopId: this.amazonShopId
      })
        .then(res => {
          this.loading = false;
          console.log(res.data.code);
          if (res.data.code !== '00000') {
            this.$message({
              type: "error",
              message: res.data.msg || "列表请求出错"
            });
            this.tableData = [];
            this.hasNextPage = false;
            return;
          }

          // 接口返回数据处理（核心逻辑）
          this.tableData = res.data.data.tableData || [];
          this.dates = res.data.data.dateList || [];

          // 判断是否有下一页：当前页数据长度等于pageSize时，认为有下一页
          // （如果接口返回hasNextPage字段，可直接使用：this.hasNextPage = res.hasNextPage）
          this.hasNextPage = this.tableData.length === this.pageSize;

          // 特殊处理：如果当前页是第一页且无数据，显示空提示
          if (this.currentPage === 1 && this.tableData.length === 0) {
            this.$message({
              type: "info",
              message: "暂无匹配数据"
            });
          }
        })
        .catch(err => {
          this.loading = false;
          this.tableData = [];
          this.hasNextPage = false;
          this.$message({
            type: "error",
            message: err.msg || "列表请求出错"
          });
        });
    },
    getShopList() {
      bigdataRequest.getShopList()
        .then(res => {
          if (res.data.code !== '00000') {
            this.$message({
              type: "error",
              message: res.data.msg || "获取店铺列表出错"
            });
            this.tableData = [];
            this.hasNextPage = false;
            return;
          }
          this.shopList = res.data.ldata;
        })
        .catch(err => {
          this.loading = false;
          this.tableData = [];
          this.hasNextPage = false;
          this.$message({
            type: "error",
            message: err.data.msg || "列表请求出错"
          });
        });
    }
  },
  mounted() {
    // 初始化日期数据（可根据实际需求从接口获取）
    // 页面加载时默认查询第一页数据
    this.getDataList();
    this.getShopList();
  }
};
</script>

<style scoped>
.expand-table-container {
  padding: 20px;
}

.pagination-container {
  margin-top: 15px;
  text-align: right;
}

/* 隐藏展开行默认内边距 */
/deep/ .el-table__expanded-cell {
  padding: 0 !important;
}

/* 展开行内表格样式优化 */
/deep/ .el-table__expanded-cell .el-table {
  margin: 0 -1px;
  border-top: none !important;
}

/* 加载状态样式优化 */
/deep/ .el-table__body-wrapper {
  min-height: 200px;
}
</style>
